"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Batcher = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _bignumber2 = require("@ethersproject/bignumber/lib/bignumber");
var _ethcall = require("@blockwell/ethcall");
var _chains = require("@blockwell/chains");
var _ChainResponse = require("./ChainResponse");
class Batcher {
  constructor(network, client) {
    (0, _defineProperty2.default)(this, "mapping", []);
    (0, _defineProperty2.default)(this, "contract", void 0);
    (0, _defineProperty2.default)(this, "batch", []);
    (0, _defineProperty2.default)(this, "chain", void 0);
    this.client = client;
    this.chain = (0, _chains.getChain)(network);
  }
  setContract(abiOrContract, address) {
    if ("functions" in abiOrContract) {
      this.contract = abiOrContract;
    } else if ("abi" in abiOrContract) {
      this.contract = new _ethcall.EthcallContract(abiOrContract.address, abiOrContract.abi);
    } else if (Array.isArray(abiOrContract)) {
      this.contract = new _ethcall.EthcallContract(address, abiOrContract);
    }
    return this;
  }
  add(method, name, args = [], callback) {
    this._add(method, name, args, "string", callback);
    return this;
  }
  try(method, name, args = [], callback, cache) {
    this._add(method, name, args, "string", callback, true, cache);
    return this;
  }
  tryAny(method, name, args = [], callback, cache) {
    this._add(method, name, args, "string", callback, true, cache);
    return this;
  }
  addInt(method, name, args = [], callback, cache) {
    this._add(method, name, args, "int", callback, false, cache);
    return this;
  }
  tryInt(method, name, args = [], callback, cache) {
    this._add(method, name, args, "int", callback, true, cache);
    return this;
  }
  tryBlockNumber(name) {
    this._addToBatch("block");
    this._addMapping({
      key: name || "blockNumber",
      type: "int"
    });
    return this;
  }
  tryEthBalance(name, account) {
    this._addToBatch(account);
    this._addMapping({
      key: name,
      type: "bignumber"
    });
    return this;
  }
  tryEthBalanceString(name, account) {
    this._addToBatch(account);
    this._addMapping({
      key: name,
      type: "string"
    });
    return this;
  }
  addBig(method, name, args = [], callback, cache) {
    this._add(method, name, args, "bignumber", callback, false, cache);
    return this;
  }
  tryBig(method, name, args = [], callback, cache) {
    this._add(method, name, args, "bignumber", callback, true, cache);
    return this;
  }
  addBigArray(method, name, args = [], callback, cache) {
    this._add(method, name, args, "bignumber", callback, false, cache);
    return this;
  }
  addBoolean(method, name, args = [], callback, cache) {
    this._add(method, name, args, "boolean", callback, false, cache);
    return this;
  }
  addStructArray(method, name, args = [], callback, cache) {
    this._add(method, name, args, "struct[]", callback, false, cache);
    return this;
  }
  tryStructArray(method, name, args = [], callback, cache) {
    this._add(method, name, args, "struct[]", callback, true, cache);
    return this;
  }
  addList(method, name, count, opt = {}, convert) {
    let start = opt.start || 0;
    let end = typeof count === "number" ? count : opt.argsList.length;
    let map = {
      key: name || method,
      count: end,
      type: "list",
      start,
      items: convert || "string"
    };
    this.addListMapping(method, map, opt);
    return this;
  }
  addListConvert(method, convert, name, count, opt = {}) {
    let start = opt.start || 0;
    let end = typeof count === "number" ? count : opt.argsList.length;
    let map = {
      key: name || method,
      count: end,
      type: "list",
      start,
      convert: convert
    };
    this.addListMapping(method, map, opt);

    // @ts-ignore
    return this;
  }
  addListMapping(method, map, opt) {
    let calls = [];
    let argsPos = 0;
    for (let i = map.start; i < map.count; i++) {
      let args;
      if (opt.args) {
        args = [];
        for (let it of opt.args) {
          if (it === true) {
            args.push(i.toString());
          } else {
            args.push(it);
          }
        }
      } else if (opt.argsList) {
        args = opt.argsList[argsPos++];
      } else {
        args = [i.toString()];
      }
      calls.push(this.contract[method](...args));
    }
    this._addCalls(calls, map);
  }
  addObjectList(name, count, props, start = 0, itemType = Object) {
    let argsList = [];
    let map = {
      key: name,
      count,
      props,
      type: "objectlist",
      args: argsList,
      start,
      itemType
    };
    let calls = [];
    for (let [key, val] of Object.entries(props)) {
      if (val.method) {
        let argsPos = 0;
        for (let i = start; i < count; i++) {
          let args;
          if (val.argsList) {
            args = val.argsList[argsPos++];
          } else if (val.args) {
            args = [];
            for (let it of val.args) {
              if (it === true) {
                args.push(i.toString());
              } else {
                args.push(it);
              }
            }
          } else {
            args = [i.toString()];
          }
          argsList.push(args);
          calls.push(this.contract[val.method](...args));
        }
      }
    }
    this._addCalls(calls, map);

    // @ts-ignore
    return this;
  }
  _add(method, name, args = [], type, callback, softFail, cache) {
    let map = {
      type,
      callback,
      key: name || method
    };
    if (!this.contract[method]) {
      if (softFail) {
        map.softFailed = true;
        this._addMapping(map);
      } else {
        throw new Error(`ABI does not have the method '${method}'`);
      }
    } else {
      let call = this.contract[method](...args);
      if (cache) {
        call.cache = cache;
      }
      this._addCalls(call, map);
    }
  }
  _addCalls(call, map) {
    if (Array.isArray(call)) {
      for (let it of call) {
        this._addToBatch(it);
      }
    } else {
      this._addToBatch(call);
    }
    this._addMapping(map);
  }
  _addMapping(map) {
    this.mapping.push(map);
  }
  _addToBatch(call) {
    this.batch.push(call);
  }
  calls() {
    return {
      chain: this.chain,
      batch: this.batch
    };
  }
  finalize(result, type) {
    let data;
    if (type) {
      data = new type();
    } else {
      data = {};
    }
    if (this.mapping.length > 0) {
      return this._mapResponses(result, data);
    } else {
      return data;
    }
  }
  async execute(type) {
    let batch = this.batch;
    let res = await this.client.multicall(this.chain, batch);
    return this.finalize(res, type);
  }
  _mapResponses(responses, data) {
    let res = [...responses];
    for (let map of this.mapping) {
      this._processMapping(res, data, map);
    }
    return data;
  }
  _processMapping(res, data, map) {
    let {
      type,
      callback
    } = map;
    // @ts-ignore
    let key = map.key;
    if (data[key]) {
      throw new Error(`Batcher data already has the key ${key.toString()}`);
    }
    if (type === "objectlist") {
      let list = [];
      for (let i = map.start; i < map.count; i++) {
        let item = new map.itemType();
        item.id = i;
        list.push(item);
      }
      let argsPos = 0;
      for (let [key, val] of Object.entries(map.props)) {
        for (let j = 0; j < map.count - map.start; j++) {
          if (val.method) {
            let args = map.args[argsPos++];
            if (val.convert) {
              val.convert(res.shift(), list[j], args);
            } else {
              list[j][key] = this._parseType(res.shift(), val.type);
            }
          } else if (typeof val.value === "function") {
            list[j][key] = val.value(list[j]);
          } else if (val.valueList) {
            list[j][key] = val.valueList[j];
          } else {
            list[j][key] = val.value;
          }
        }
      }
      // @ts-ignore
      data[key] = list;
    } else if (type === "list") {
      let list = [];
      for (let j = map.start; j < map.count; j++) {
        let value = res.shift();
        if (map.convert) {
          list.push(map.convert(value, j));
        } else {
          list.push(this._parseType(value, map.items));
        }
      }
      // @ts-ignore
      data[key] = list;
    } else if (map.softFailed) {
      data[key] = null;
    } else {
      let parsed = this._parseType(res.shift(), type);
      // @ts-ignore
      data[key] = parsed;
      if (callback) {
        callback(data[key]);
      }
    }
  }
  _parseType(val, type) {
    if (val !== null && val !== void 0 && val.hasOwnProperty(_ethcall.CALL_ERROR)) {
      return val;
    }
    if (type === "struct") {
      if ((0, _ChainResponse.isStructResponse)(val)) {
        return this.parseStruct(val);
      }
      return null;
    }
    if (type === "struct[]") {
      if ((0, _ChainResponse.isArrayResponse)(val)) {
        return val.map(it => {
          if ((0, _ChainResponse.isStructResponse)(it)) {
            return this.parseStruct(it);
          }
          return null;
        });
      }
      return null;
    }
    if ((0, _ChainResponse.isArrayResponse)(val)) {
      return val.map(it => {
        return this._parseType(it, type);
      });
    }
    if ((0, _ChainResponse.isPrimitiveResponse)(val)) {
      return this._parseSingle(val, type);
    }
    if ((0, _ChainResponse.isStructResponse)(val)) {
      return this.parseStruct(val);
    }
    return null;
  }
  parseStructValue(value) {
    if ((0, _ChainResponse.isPrimitiveResponse)(value)) {
      return this._parseSingle(value);
    } else if ((0, _ChainResponse.isStructResponse)(value)) {
      return this.parseStruct(value);
    } else if ((0, _ChainResponse.isArrayResponse)(value)) {
      if (value.length === 0) {
        return [];
      } else {
        return value.map(it => {
          return this.parseStructValue(it);
        });
      }
    }
  }
  parseStruct(val) {
    let converted = {};
    for (let [key, value] of Object.entries(val)) {
      if (!/^\d+$/.test(key)) {
        converted[key] = this.parseStructValue(value);
      }
    }
    return converted;
  }
  _parseSingle(val, type) {
    if (type === "string") {
      return val === null || val === void 0 ? void 0 : val.toString();
    }
    if (type === "int") {
      if ((0, _bignumber2.isBigNumberish)(val)) {
        return new _bignumber.default(val).toNumber();
      } else {
        return NaN;
      }
    }
    if (type === "bignumber") {
      if ((0, _bignumber2.isBigNumberish)(val)) {
        return new _bignumber.default(val);
      } else {
        return new _bignumber.default(NaN);
      }
    }
    if (type === "boolean") {
      return val === true || val === "true";
    }
    if (typeof val === "number" || typeof val === "boolean") {
      return val;
    }
    return val === null || val === void 0 ? void 0 : val.toString();
  }
}
exports.Batcher = Batcher;
//# sourceMappingURL=Batcher.js.map